import { fetchBlob } from '../../fetchBlob';
import environment from '../../../environment';
import { notifyError } from '../../../shared';
import fetch from '../../fetch';

const baseUrl = `${environment.get('API_HOST')}/distanceReport`;

export class Distances {
    static getDailyQuotasLeft = (): Promise =>
        fetch({
            type: 'GET',
            url: `${baseUrl}/DailyQuotaLeft/`,
        });

    static getReportStoreToStores = (idStore: number, nameStore: string): Promise =>
        fetchBlob({
            fileName: `Nearest stores from ${nameStore}.xlsx`,
            url: `${baseUrl}/ClosestStoresFromStore/${idStore}`,
        });

    static getReportStoreToSameBrandStores = (idStore: number, nameStore: string): Promise =>
        fetchBlob({
            fileName: `Nearest same brand stores from ${nameStore}.xlsx`,
            url: `${baseUrl}/ClosestSameBrandStoresFromStore/${idStore}`,
        });

    static getReportStoreToOperationalAreas = (idStore: number, nameStore: string): Promise =>
        fetchBlob({
            fileName: `Nearest operational areas from ${nameStore}.xlsx`,
            url: `${baseUrl}/ClosestOperationAreasFromStore/${idStore}`
        });

    static getReportCityToStores = (idCity: number, nameCity: string): Promise =>
        fetchBlob({
            fileName: `Nearest store from ${nameCity}.xlsx`,
            url: `${baseUrl}/ClosestStoresFromLocation/${idCity}`
        });

    static getReportCityToOperationalAreas = (idCity: number, nameCity: string): Promise =>
        fetchBlob({
            fileName: `Nearest operational areas from ${nameCity}.xlsx`,
            url: `${baseUrl}/ClosestOperationAreasFromLocation/${idCity}`
        });
}



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/distance/distances.js